import { useKtx2PreloadBridge } from './ktx2Textures'

export function Ktx2TexturePreloadBridge() {
    useKtx2PreloadBridge()
    return null
}
